/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.19.0
 */

import { useDispatch, useSelector } from 'react-redux';

import { TABLE_WIDTH_MAX, TABLE_WIDTH_MIN } from '../constants';
import { tableContext, tableMetaUrlSelector, tableResizeUrlSelector } from '../selectors';
import { tableApi } from '../store';

export const useTableResizeApi = () => {

    const dispatch = useDispatch();

    /* API */
    const [resizeTable] = tableApi.endpoints.resizeTable.useMutation();

    /* Selectors */
    const metaUrl = useSelector(tableMetaUrlSelector);
    const resizeUrl = useSelector(tableResizeUrlSelector);

    /* Контекст для основных операций*/
    const context = useSelector(tableContext);

    return {
        resize: (columnId: string, columnSize: number) => {
            if (!metaUrl) {
                // eslint-disable-next-line no-throw-literal
                throw '[Table]: incorrect table configuration. Set metaUrl in initialize method';
            }

            if (resizeUrl && !!columnSize) {
                let size = Math.round(columnSize);
                if (size > TABLE_WIDTH_MAX) {
                    size = TABLE_WIDTH_MAX;
                } else if (size < TABLE_WIDTH_MIN) {
                    size = TABLE_WIDTH_MIN;
                }
                dispatch(tableApi.util.updateQueryData('getTableMeta', { url: metaUrl, context }, (draft) => {
                    draft.fields = draft.fields.map(field => {
                        return field.name === columnId ? { ...field, size } : field;
                    });
                }));
                resizeTable({ url: resizeUrl, columnId, columnSize: size });
            } else {
                // TODO: throw error
            }
        },
    };
};
